const slideBarDeliveryRouter = [
  {
    path: '/s-delivery',
    name: 's-delivery',
    component: () => import('@/views/slideBar/deliverOnline/'),
    meta: {
      title: '工地在线'
    },
    children: [
      {
        path: 'home',
        name: 's-delivery-home',
        component: () => import('@/views/slideBar/deliverOnline/staff/home.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'complete',
        name: 's-delivery-complete',
        component: () => import('@/views/slideBar/deliverOnline/staff/complete/index.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'confide',
        name: 's-delivery-confide-order',
        component: () => import('@/views/slideBar/deliverOnline/staff/confide/index.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'confide-create',
        name: 's-delivery-confide-create',
        component: () => import('@/views/slideBar/deliverOnline/staff/confide/create.vue'),
        meta: {
          title: '交付在线'
        }
      },
      // =====================shiqiong=========================
      {
        path: 'invitation-completed',
        name: 'invitation-completed',
        component: () => import('@/views/slideBar/deliverOnline/customer/completed/invitation.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'success-completed',
        name: 'success-completed',
        component: () => import('@/views/slideBar/deliverOnline/customer/completed/success.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'invitation-disclosure',
        name: 'invitation-disclosure',
        component: () => import('@/views/slideBar/deliverOnline/customer/disclosure/invitation.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'success-disclosure',
        name: 'success-disclosure',
        component: () => import('@/views/slideBar/deliverOnline/customer/disclosure/success.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'construction-progress',
        name: 'construction-progress',
        component: () => import('@/views/slideBar/deliverOnline/customer/construction-progress/index.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'customerList',
        name: 'customerList',
        component: () => import('@/views/slideBar/deliverOnline/staff/customer-complaint/list.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'handling',
        name: 'handling',
        component: () => import('@/views/slideBar/deliverOnline/staff/customer-complaint/problem-handling.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'distribution',
        name: 'distribution',
        component: () => import('@/views/slideBar/deliverOnline/staff/customer-complaint/distribution.vue'),
        meta: {
          title: '交付在线'
        }
      },
      {
        path: 'handle',
        name: 'handle',
        component: () => import('@/views/slideBar/deliverOnline/staff/customer-complaint/handle.vue'),
        meta: {
          title: '交付在线'
        }
      }
    ]
  }
]
export default slideBarDeliveryRouter
